export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/404-2df8aa5404d3e85d2fba5a57755a38e9.png";